import { Action, Selector, State, StateContext, Store } from "@ngxs/store";
import { Injectable } from "@angular/core";
import { CompanyContactRequestService } from "../../services/request/company-contact-request.service";
import { CompanyContactInfoOverlayAction } from "./company-contact-info-overlay.actions";
import { Observable, throwError } from "rxjs";
import { map } from "rxjs/operators";
import { CompanyContactDtoModel } from '../../models/company-contact/company-contact-dto.model';

interface CompanyContactInfoOverlyStateModel {
  visible: boolean;
  companyContactId: number;
  companyContact: CompanyContactDtoModel;
  selectedContactPersonId: number;
}

const getDefaults = (): CompanyContactInfoOverlyStateModel => ({
  visible: false,
  companyContactId: null,
  companyContact: null,
  selectedContactPersonId: null
});

@State<CompanyContactInfoOverlyStateModel>({
  name: 'companyContactInfoOverlay',
  defaults: getDefaults()
})
@Injectable()
export class CompanyContactInfoOverlayXsState {

  // region constructor
  constructor(private companyContactRequestService: CompanyContactRequestService,
              private store: Store) {}
  // endregion

  // region selector
  @Selector()
  static visible(state: CompanyContactInfoOverlyStateModel): boolean {
    return state.visible;
  }

  @Selector()
  static companyContact(state: CompanyContactInfoOverlyStateModel): CompanyContactDtoModel {
    return state.companyContact;
  }

  @Selector()
  static selectedContactPersonId(state: CompanyContactInfoOverlyStateModel): number {
    return state.selectedContactPersonId;
  }
  // endregion

  // region actions
  @Action(CompanyContactInfoOverlayAction.OpenInfoOverlay)
  openInfoOverlay(
    ctx: StateContext<CompanyContactInfoOverlyStateModel>, action: CompanyContactInfoOverlayAction.OpenInfoOverlay
  ): Observable<void> {
    const state: CompanyContactInfoOverlyStateModel = ctx.getState();

    if (!action.companyContactId) {
      return throwError(() => new Error('Company contact id cannot be null!'));
    }

    return this.companyContactRequestService.getCompanyContact(action.companyContactId)
      .pipe(map((companyContact: CompanyContactDtoModel) => {

        // if the selectedContactId provided we should move the contactPerson with the provided id into the first place
        if (action.selectedContactId) {
          companyContact.contactPersons.sort(
            (a, b) => a.id === action.selectedContactId ? -1 :
              (b.id === action.selectedContactId ? 1 : 0)
          );
        }

        ctx.patchState({
          visible: true,
          companyContactId: action.companyContactId,
          companyContact,
          selectedContactPersonId: action.selectedContactId
        });
      }));
  }

  @Action(CompanyContactInfoOverlayAction.CloseInfOverlay)
  reset(ctx: StateContext<CompanyContactInfoOverlyStateModel>): void {
    ctx.setState(getDefaults);
  }

  // endregion

}
